import React, { useState } from "react";
import ContactForm from "../Molecules/ContactForm";
import sendEmail from "../../utils/EmailService";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

interface ContactFormProps {}

const ContactSection: React.FC<ContactFormProps> = () => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    const templateParams = {
      user_name: name,
      user_email: email,
      message: message,
    };
    try {
      await sendEmail(templateParams);
      await Swal.fire({
        icon: "success",
        title: t("contact.successTitle"),
        text: t("contact.successMessage"),
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error("woopp error to send Email.");
      Swal.fire({
        icon: "error",
        title: t("contact.errorTitle"),
        text: t("contact.errorMessage"),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="contact" className="relative">
      <div className="container px-5 py-0 mx-auto flex sm:flex-nowrap flex-wrap justify-center">
        <ContactForm
          onSubmit={handleSubmit}
          name={name}
          email={email}
          message={message}
          setName={setName}
          setEmail={setEmail}
          setMessage={setMessage}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
};

export default ContactSection;
